export enum SubscriptionStatus {
  READY = 'ready',
  CANCELLING = 'cancelling',
  NOT_READY = 'not_ready',
  PAUSED = 'paused',
  CANCELLED = 'cancelled'
}

// Ready once it can send (scenarios are Leedpulse only); a Leedflow number keeps cancelling until plan_end
export const subscriptionSetupStatus = ({ status, hasSenders, hasScenarios, isLeedflow }: { status?: SubscriptionStatus | string; hasSenders: boolean; hasScenarios: boolean; isLeedflow: boolean }): SubscriptionStatus => {
  if (status === SubscriptionStatus.PAUSED || status === SubscriptionStatus.CANCELLED) return status;
  if (status === SubscriptionStatus.CANCELLING && isLeedflow) return status;
  return hasSenders && (hasScenarios || isLeedflow) ? SubscriptionStatus.READY : SubscriptionStatus.NOT_READY;
};

// A number keeps its service until its cancellation takes effect: only paused and cancelled ones are cut
export const isSubscriptionServed = (status?: SubscriptionStatus | string): boolean =>
  !status || status === SubscriptionStatus.READY || status === SubscriptionStatus.NOT_READY || status === SubscriptionStatus.CANCELLING;

export const subscriptionStatusAsString = (status: SubscriptionStatus | string): string => {
  switch (status) {
    case SubscriptionStatus.READY:
      return 'Activé';
    case SubscriptionStatus.CANCELLING:
      return 'Résiliation en cours';
    case SubscriptionStatus.NOT_READY:
      return 'Non activé';
    case SubscriptionStatus.PAUSED:
      return 'En pause';
    case SubscriptionStatus.CANCELLED:
      return 'Résilié';
    default:
      return 'Statut inconnu';
  }
};